// @flow
import React, { type Node } from 'react';

import type { Mark } from 'app/dataTypes/Mark.types';

import MarkList from '../../../MarkList';
import styles from './Marks.scss';


type Props = {
  marks: Array<Mark>,
  children: Node,
}

const Marks = ({ marks, children }: Props): Node => {
  return (
    <div className={styles.root}>
      <div className={styles.marks}>
        <MarkList
          marks={marks}
          overflowClassName={styles.marksOverflowed}
        />
      </div>

      {children}
    </div>
  );
};

export default Marks;
